// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBKDQqczQmpTv0ByVlaRhD_WhLEGpEGaVs",
  authDomain: "first-project-d233e.firebaseapp.com",
  projectId: "first-project-d233e",
  storageBucket: "first-project-d233e.firebasestorage.app",
  messagingSenderId: "307390033878",
  appId: "1:307390033878:web:74d2dee87ddd8f8a577e77",
  measurementId: "G-DZDN3YSC6N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Analytics pode falhar em ambientes sem IndexedDB (ex: Jest) ou em setups restritos.
// Exportamos uma promise opcional para quem quiser usar analytics sem quebrar a app/testes.
export const analyticsPromise = (async () => {
  try {
    const supported = await isSupported();
    if (!supported) return null;
    return getAnalytics(app);
  } catch {
    return null;
  }
})();

export { db };
